export function separator(item: any, widgetName: string) {
	return null;
}